import * as React from 'react';

function Description() {
    return(
        <React.Fragment>
            <div className="desc">
                <div className="indexLogo">
                    <img id="logo-big" src={require('../../../Media/rollin_red_logo.png')} alt="rollin logo" />
                </div>

                <div className="description">
                        ¿Te imaginas <span className='highlight'>cuánto tiempo podrías ahorrar</span> si no tuvieras que 
                        buscar cientos de procesos judiciales en línea? En <span className='highlight rollin'>rollin </span> 
                        entendemos que el seguimiento de procesos judiciales puede ser tedioso, especialmente ahora que 
                        la pandemia ha complicado aún más el proceso. 
                        <pre></pre>
                        Por eso, hemos creado una plataforma que te permitirá tener <span className='highlight'>acceso 
                        centralizado</span> a todos tus procesos con su información y actuaciones, para que 
                        <span className='highlight'> puedas dedicar tu tiempo a lo importante</span>: conciliaciones, 
                        estrategias de litigio y mucho más. 
                        <pre></pre>
                        Nuestro objetivo es <span className='highlight'>hacerte la vida más fácil</span>, por lo que 
                        nos encargamos de <span className='highlight'>mantenerte actualizado en todo momento</span>. Te 
                        enviaremos notificaciones cuando haya nuevas actuaciones en tus procesos, para que 
                        <span className='highlight'> solo tengas que revisarlos cuando sea necesario</span>. 
                        Además, si se cargan nuevos documentos, te los enviaremos directamente a tu correo electrónico 
                        para que no tengas que perder tiempo buscándolos.
                        <pre></pre>
                        Con <span className='highlight rollin'>rollin</span> , podrás <span className='highlight'>
                        disfrutar de todo el tiempo libre</span> que tendrás al no tener que buscar procesos 
                        judiciales. 
                        <pre></pre>    
                        <div className='description-center'>
                            ¡<span className='highlight'>Ahorra tiempo&#160;</span> y mejora la 
                            <span className='highlight'> &#160;productividad &#160;</span> de tu organización 
                            con nuestra plataforma!
                        </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export { Description }